'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _reduxWindow = require('redux-window');
var _addressLookup = require('../../actions/address-lookup');
var _updateFields = require('../../actions/update-fields');
var _formInfo = require('../../selectors/form-info');
var _addressLookup2 = require('../../selectors/address-lookup');
var _withFormId = require('../../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _lookup = require('./lookup');
var _lookup2 = _interopRequireDefault(_lookup);
var _multiple = require('./multiple');
var _multiple2 = _interopRequireDefault(_multiple);
var _manual = require('./manual');
var _manual2 = _interopRequireDefault(_manual);
var _details = require('./details');
var _details2 = _interopRequireDefault(_details);
var _pick = require('lodash/pick');
var _pick2 = _interopRequireDefault(_pick);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultName = 'address';
var defaultLabel = 'Address';
var fields = ['Line1', 'Line2', 'TownCity', 'County', 'Postcode', 'BuildingNameNumber', 'Options'];
var AddressLookup = function (_Component) {
  _inherits(AddressLookup, _Component);
  function AddressLookup(props) {
    _classCallCheck(this, AddressLookup);
    var _this = _possibleConstructorReturn(this, (AddressLookup.__proto__ || Object.getPrototypeOf(AddressLookup)).call(this, props));
    _initialiseProps.call(_this);
    props.initialiseAddressLookup(props.formId, props.name, props.defaultPostcode);
    return _this;
  }
  _createClass(AddressLookup, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // stop address from slipping out of view when state changes
      if (this.props.mobile && this.props.addressView !== prevProps.addressView) {
        document.getElementById(this.props.name).scrollIntoView();
        // the scrollOffset is for working with fixed headers (and the like...)
        window.scroll(0, window.scrollY - this.props.scrollOffset);
      }
      if (this.props.errors && !prevProps.errors) {
        this.props.setView(this.props.formId, this.props.name || defaultName, 'manual');
      }
    }
  }, {
    key: 'createFieldName',
    value: function createFieldName(field) {
      return this.props.name + field;
    }
  }, {
    key: 'createFieldNames',
    value: function createFieldNames() {
      var _this2 = this;
      return fields.reduce(function (acc, field) {
        return Object.assign({}, acc, _defineProperty({}, field, _this2.createFieldName(field)));
      }, {});
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        id: this.props.name
      }, this.selectView());
    }
  }]);
  return AddressLookup;
}(_react.Component);
AddressLookup.propTypes = {
  // props
  name: _propTypes.string,
  label: _propTypes.string,
  scrollOffset: _propTypes.number,
  defaultPostcode: _propTypes.string,
  // withFormId
  formId: _propTypes.string.isRequired,
  // stp
  addressView: (0, _propTypes.oneOf)(['lookup', 'loading', 'multiple', 'manual', 'details']).isRequired,
  mobile: _propTypes.bool.isRequired,
  // dtp
  resetFields: _propTypes.func.isRequired,
  clearAddress: _propTypes.func.isRequired,
  initialiseAddressLookup: _propTypes.func.isRequired,
  errors: _propTypes.bool.isRequired,
  setView: _propTypes.func.isRequired
};
AddressLookup.defaultProps = {
  name: defaultName,
  label: defaultLabel,
  scrollOffset: 100,
  defaultPostcode: undefined
};
var _initialiseProps = function _initialiseProps() {
  var _this3 = this;
  this.clearAddress = function () {
    _this3.props.clearAddress(_this3.props.formId, _this3.props.name);
    _this3.props.resetFields(_this3.props.formId, fields.map(function (field) {
      return _this3.createFieldName(field);
    }));
  };
  this.selectView = function () {
    var props = {
      fieldNames: _this3.createFieldNames(),
      name: _this3.props.name,
      label: _this3.props.label !== defaultLabel ? _this3.props.label : null,
      clearAddress: _this3.clearAddress
    };
    switch (_this3.props.addressView) {
      case 'loading':
        return _react2.default.createElement(_loading2.default, null);
      case 'multiple':
        return _react2.default.createElement(_multiple2.default, props);
      case 'manual':
        return _react2.default.createElement(_manual2.default, props);
      case 'details':
        return _react2.default.createElement(_details2.default, props);
      default:
        return _react2.default.createElement(_lookup2.default, props);
    }
  };
};
var hasErrors = function hasErrors(state, ownProps) {
  var errors = (0, _pick2.default)((0, _formInfo.getErrors)(state, ownProps.formId), fields.map(function (field) {
    return '' + (ownProps.name || defaultName) + field;
  }));
  return Object.keys(errors).some(function (error) {
    return errors[error];
  });
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    addressView: (0, _addressLookup2.addressView)(state, ownProps.formId, ownProps.name || defaultName),
    mobile: (0, _reduxWindow.getWidth)(state) < 768,
    errors: hasErrors(state, ownProps)
  };
}, {
  clearAddress: _addressLookup.clearAddress,
  initialiseAddressLookup: _addressLookup.initialiseAddressLookup,
  resetFields: _updateFields.resetFields,
  setView: _addressLookup.setView
})(AddressLookup));